import { useEffect, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

import { AdyenRedirect } from './AdyenRedirect'

type AdyenRedirectPageProps = {
  children: ReactNode
}

export function AdyenRedirectPage({ children }: AdyenRedirectPageProps) {
  const { pathname } = useLocation()
  const parentRoute = pathname.replace(/\/adyen-redirect$/, '') || '/'

  useEffect(() => {
    window.history.replaceState(null, '', parentRoute)
  }, [parentRoute])

  return (
    <>
      {children}
      <AdyenRedirect />
    </>
  )
}
